export default "__VITE_ASSET__a7b499a3__"